import React, { useMemo, useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";


import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const OrderView = () => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);

    const columnDefs = useMemo(() => [
        { field: "sitemanager", headerName: "Bauleiter" },
        { field: "ort", headerName: "Ort" },
        { field: "baustelle", headerName: "Baustelle" },
        { field: "auftraggeber", headerName: "Auftraggeber" },
        { field: "baustellenNr", headerName: "Baustellen-Nr." },
        { field: "processes.amount", headerName: "Auftragssumme" },
        { field: "mischanlage", headerName: "Mischanlage" },
        { field: "kolAsphalt", headerName: "Kol. Asphalt" },
        { field: "mannSonst", headerName: "Mann Sonst." },
        { field: "fraesen", headerName: "Fräsen" },
        { field: "to", headerName: "to" },
        { field: "bauzeit", headerName: "geplante Bauzeit" },
        { field: "bemerkung", headerName: "Bemerkung" },
        { field: "ats", headerName: "ATS" },
        { field: "ads", headerName: "ADS" },
        { field: "atds", headerName: "ATDS" },
        { field: "abi", headerName: "A´BI" },
        { field: "sma", headerName: "SMA" },
        { field: "sondermischgut", headerName: "Sondermischgut" },
        { field: "erledigt", headerName: "erledigt" },
        { field: "teilfertig", headerName: "teilfertig?" },
        { field: "tageRest", headerName: "TAGE Rest" },
        { field: "fortlNummer", headerName: "fortl. Nummer" },
        { field: "status", headerName: "Status Wochenplan" },
        { field: "abZurueck", headerName: "AB unterschrieben zurück?" },
        { field: "woche", headerName: "eingeplante Woche" },
        { field: "spalte1", headerName: "Spalte1" }
    ], []);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        floatingFilter: true,
        resizable: true
    }), []);

    useEffect(() => {
        const fetchProjects = async () => {
            const jwttoken = localStorage.getItem("binfra_token");
    
            try {
                const { data } = await axios.get(
                    "https://dev-nishal.api.bpo-projekt.de/api/pre-projects?v=6&page=1&limit=10",
                    {
                        headers: {
                            Authorization: `Bearer ${jwttoken}`,
                        },
                    }
                );
    
                const projects = data.data.flat().map(project => ({
                    id: project.id,
                    baustelle: project.title,
                    baustellenNr: project.constructionSiteNo,
                    auftraggeber: project.customerName,
                    ort: project.location.city,
                    bemerkung: project.location.address,
                    fortlNummer: project.costCentre,
                
                    bauleiter:
                        project.contacts.length > 0
                            ? project.contacts[0].name
                            : "",
                
                    bauzeit:
                        project.processes.length > 0
                            ? project.processes[0].start_date
                            : "",
                
                    status: project.deleted ? "Deleted" : "Active"
                }));
                // Adjust depending on your API response
                setRowData(projects);
            } catch (error) {
                console.error("Error fetching projects:", error);
            }
        };
    
        fetchProjects();
    }, []);

    return (
        <div
            className="ag-theme-alpine"
            style={{ height: "800px", width: "100%" }}
        >
            <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                loading={loading}
            />
        </div>
    );
};

export default OrderView;